export enum MessageClassType {
    Device = <any> 'Device',
    Event = <any> 'Event',
    Service = <any> 'Service'
}
